import { Theme } from '@mui/material/styles'
import { RadioProps } from '@mui/material/Radio'
//
import { RadioIcon, RadioCheckedIcon } from './CustomIcons'
import { hoverRing } from '../interaction'

// ----------------------------------------------------------------------

export default function Radio(theme: Theme) {
  return {
    MuiRadio: {
      defaultProps: {
        icon: <RadioIcon />,
        checkedIcon: <RadioCheckedIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: RadioProps }) => ({
          padding: theme.spacing(1),
          // MUI computes a selection control's hover from its colour prop, and both
          // Checkbox and Radio default to `color="primary"` — which is navy. Every
          // checkbox in the app was hovering cool blue inside warm-grey chrome.
          //
          // The ring is a fixed size rather than the padding's, so a call site that
          // shrinks the control to fit a row does not shrink its hover with it.
          ...hoverRing(theme),
          // On-state is navy, the kit's selected colour, never amber: amber is 1.54:1
          // on white and fails the 3:1 control-boundary rule — amber means action.
          // :not(.Mui-disabled) keeps MUI's disabled styling winning, so a
          // disabled checked control still reads as disabled.
          '&.Mui-checked:not(.Mui-disabled)': {
            color: theme.palette.primary.main,
          },
          ...(ownerState.size === 'small' && {
            '& svg': { width: 20, height: 20 },
          }),
          ...(ownerState.size === 'medium' && {
            '& svg': { width: 24, height: 24 },
          }),
        }),
      },
    },
  }
}
